import React from "react";
import { Button } from "@sincro/react-button";
import {
  Card,
  CardActions,
  CardHeader,
  CardMedia,
  CardText,
  CardTitle
} from "@sincro/react-card";
import { TrackedElement } from "@sincro/react-tracked-element";
import { makePascalCase, sanitizeText } from "../analytics/AnalyticsUtil";

export const AnnouncementCard = ({
  copy,
  externalLink,
  hyperlink,
  title,
  image,
  video
}) => {
  const openUrlInNewWindow = url => {
    window.open(url, "_blank");
  };

  return (
    <Card className="sincro-announcement-card">
      {video ? (
          <figure>
            <iframe
                width="560"
                height="315"
                src={video.url}
                title={video.name}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
            ></iframe>
          </figure>
      ) : (
      image && (
        <CardMedia className="announcement-image">
          <img
            src={`${image.url}`}
            alt={image.altText}
            title={image.altText}
            loading="lazy"
          />
        </CardMedia>
      ))}
      <div className="announcement-body">
        <CardHeader>
          <CardTitle large className="announcement-title">
            <span dangerouslySetInnerHTML={{ __html: title }}></span>
          </CardTitle>
        </CardHeader>
        <CardText className="announcement-copy">
          <span dangerouslySetInnerHTML={{ __html: copy }}></span>
        </CardText>

        {(hyperlink || externalLink) && (
          <CardActions fullBleed className="announcement-ctas">
            {hyperlink && (
              <TrackedElement
                type={`navigate|${hyperlink.url}`}
                name={`DCC|Announcements|${makePascalCase(
                  sanitizeText(title)
                )}`}
              >
                <Button
                  className="hyper-link"
                  onClick={() => openUrlInNewWindow(hyperlink.url)}
                  outlined
                  unelevated
                >
                  {hyperlink.label}
                </Button>
              </TrackedElement>
            )}
            {externalLink && (
                <TrackedElement
                    type={`navigate|${externalLink.url}`}
                    name={`DCC|Announcements|${makePascalCase(
                        sanitizeText(title)
                    )}`}
                >
                  <Button
                      className="external-link"
                      onClick={() => openUrlInNewWindow(externalLink.url)}
                  >
                    {externalLink.label}
                  </Button>
                </TrackedElement>
            )}
          </CardActions>
        )}
      </div>
    </Card>
  );
};
